(ns dre.pages.admin.ai-summarization-usage.views
  (:require
   ["antd" :refer [Spin Divider Popover]]
   [clojure.string :as str]
   [clojure.walk :as w]
   [dre.app.router :as router :refer [->route]]
   [dre.components.icon :refer [fa-icon icon]]
   [dre.components.pill :as pill-component]
   [dre.components.range-picker :refer [range-picker]]
   [dre.components.select :refer [select]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.components.table :refer [table]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [dre.pages.admin.ai-summarization-usage.events :as usage]
   [dre.pages.admin.views :refer [nav-tabs]]
   [dre.widgets.question-answering.views :as qa-view]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :admin-ai-summary)

(defn- search-filters
  []
  (let [checkbox (fn [id label]
                   [:div.input-group
                    [:input.input {:type :checkbox
                                   :id id
                                   :checked @(rf/subscribe [::usage/value-of-filter id])
                                   :on-change #(rf/dispatch [::usage/on-filter-change id (.. % -target -checked)])}]
                    [:label.label {:for id} [tr label]]])]
    [:div
     {:class (bem/be component-name :search-filters)}
     [range-picker
      {:on-change #(rf/dispatch [::usage/on-date-filter-change %])
       :presets :default
       :value [@(rf/subscribe [::usage/value-of-filter :from])
               @(rf/subscribe [::usage/value-of-filter :to])]}]
     [checkbox :include-dre "Include DRE"]
     [checkbox :include-browser "Include browser calls"]
     [checkbox :include-api "Include API calls"]
     [select
      {:showSearch true
       :allowClear true
       :suffixIcon (r/as-element [icoinor-icon :nav-arrow-down])
       :disabled @(rf/subscribe [::usage/value-of-filter :username])
       :value @(rf/subscribe [::usage/value-of-filter :client])
       :onChange #(rf/dispatch [::usage/on-filter-change :client %])
       :placeholder [tr "Filter by client"]
       :options @(rf/subscribe [::usage/client-list-datasource])}]
     [select
      {:showSearch true
       :allowClear true
       :suffixIcon (r/as-element [icoinor-icon :nav-arrow-down])
       :disabled @(rf/subscribe [::usage/value-of-filter :client])
       :value @(rf/subscribe [::usage/value-of-filter :username])
       :onChange #(rf/dispatch [::usage/on-filter-change :username %])
       :placeholder [tr "Filter by username"]
       :options @(rf/subscribe [::usage/user-list-datasource])}]]))

(defn- search-submit
  [state]
  [:div
   {:class (bem/be component-name :search-submit)}
   [:button.button.button--brand
    {:on-click #(rf/dispatch [::router/redirect-to-handler-with-query-params :admin-ai-summarization-usage (usage/filters->url state)])}
    [tr "Go!"]]])

(defn- render-answer
  [meta preview?]
  (let [answer-str (get-in (first (get-in meta [:answer :choices])) [:message :content])
        answer-str (if preview?
                     (str (str/join "" (take 100 answer-str)) (when (> (count answer-str) 100) "..."))
                     answer-str)]
    [qa-view/answer-with-references
     answer-str
     (into {} (map-indexed (fn [idx article] [(:article/guid article) (inc idx)]) (:article/ids meta)))
     (into {} (map (fn [article] [(:article/guid article) {:title (:article/title article)
                                                           :abstract-by-sentences (mapv :text
                                                                                        (filter #(some
                                                                                                  (fn [v] (= "article/abstract" v))
                                                                                                  (:tags %))
                                                                                                (:article/sentences article)))}])
                   (:article/ids meta)))]))

(defn- events-results
  [result-count]
  [:<> 
   [table
    {:title (fn [] (when
                    result-count
                     (r/as-element [:span
                                    (str
                                     result-count
                                     " Results ")
                                    [:button
                                     {:on-click (fn [e] (rf/dispatch [::modals/set-modal :usage/ai-summarization-usage @(rf/subscribe [::usage/filters])]))
                                      :class [(bem/bm :button :brand)]}
                                     "Export"]])))
     :expandable {:expandedRowRender (fn [record]
                                       (let [r (js->clj record)
                                             meta (w/keywordize-keys (get r "meta"))]
                                         (r/as-element (render-answer meta false))))
                  :rowExpandable (fn [record]
                                   true)}
     :columns [{:title [tr "Time"]
                :dataIndex :time}
               {:title [tr "Email"]
                :dataIndex :email}
               {:title [tr "Client"]
                :dataIndex :client}
               {:title [tr "Prefiltering Query"]
                :dataIndex :pills
                :render (fn [{:keys [pills]}]
                          [pill-component/readonly-pills pills nil nil nil {}])}
               {:title [tr "Question"]
                :render (fn [{:keys [meta]}]
                          (:question meta))}
               {:title [tr "Answer"]
                :render (fn [{:keys [meta]}]
                          (render-answer meta true))}
               {:title [tr "References"]
                :render (fn [{:keys [meta]}]
                          (let [guid-idx (into {} (map-indexed (fn [idx article] [(:article/guid article) (inc idx)]) (:article/ids meta)))]
                            [:<>
                             (map
                              (fn [a]
                                ^{:key (str "ai-sum-usage-" (:article/guid a))}
                                [:> Popover
                                 {:content (r/as-element (qa-view/render-article a guid-idx))
                                  :trigger :hover
                                  :rootClassName :ant-theme
                                  :placement :top
                                  :overlayStyle {:max-width "80%"
                                                 :overflow-y "auto"}}
                                 [:a
                                  {:class (bem/be :qa-widget :answer-reference)
                                   :target "_blank"
                                   :href (->route :detail {:id (name (:article/guid a))})}
                                  (guid-idx (:article/guid a))]])
                              (:article/ids meta))]))}
               {:title [tr "Number of References"]
                :render (fn [{:keys [meta]}]
                          (if (seq (:selected-articles meta))
                            "-"
                            (:top-k meta)))}
               {:title [tr "Vote"]
                :render (fn [{:keys [vote-meta]}]
                          (let [vote (get vote-meta :vote nil)
                                vote-feedback (get vote-meta :vote-feedback nil)]
                            (case vote
                              true [fa-icon :thumbs-up]
                              false [tooltip-wrapper (r/as-element (if vote-feedback
                                                                     [:span
                                                                      [:p [:b "Issues: "] (str/join "," (get vote-feedback :issues []))]
                                                                      [:p [:b "Feedback: "] (get vote-feedback :feedback "")]]
                                                                     "No additional feedback from user.")) [:span [fa-icon :thumbs-down]]]
                              nil "-")))}
               {:title [tr "Source types"]
                :render (fn [{:keys [meta]}]
                          (or (:sources-type meta) "-"))}
               {:title [tr "Model"]
                :render (fn [{:keys [meta]}]
                          (or (:drevidence-model meta) "-"))}
               {:title [tr "Single article?"]
                :render (fn [{:keys [meta]}]
                          (or (when (seq (:selected-articles meta)) "Yes") "No"))}]
     :pagination {:position [:topLeft :bottomLeft]
                  :total (get-in @(rf/subscribe [::usage/events]) [:response :count])
                  :pageSize (get-in @(rf/subscribe [::usage/events]) [:pagination :limit])
                  :defaultPageSize (get-in @(rf/subscribe [::usage/events]) [:pagination :limit])
                  :current (get-in @(rf/subscribe [::usage/events]) [:pagination :current-page])
                  :onChange (fn [page pageSize]
                              (rf/dispatch [::usage/fetch-report
                                            {:type :events
                                             :endpoint :admin/usage.ai-summary-events
                                             :updated-pagination {:limit pageSize
                                                                  :offset (* (- page 1) pageSize)
                                                                  :current-page page}}]))}
     :dataSource @(rf/subscribe [::usage/events-datasource])}]])

(defn- results-container
  []
  [:div
   {:class (bem/be component-name :results-container)}
   [events-results (get-in @(rf/subscribe [::usage/events]) [:response :count])]])

(defn view
  []
  (let [state @(rf/subscribe [::usage/state])
        events-state @(rf/subscribe [::usage/events-state])]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [nav-tabs]]
     [:> Spin
      {:spinning (or (= (get-in state [:users-list :state]) :loading)
                     (= (get-in state [:client-list :state]) :loading)
                     (= events-state :loading))}
      [:div {:class (bem/be component-name :content)}
       [search-filters]
       [search-submit state]
       [results-container]]]]))
